
import { isLabelContentType, LabelContentItem, setOrDeleteLabel } from '@tableau/catalog-ui-temp';
import { restApiService } from '@tableau/vizportalclient-common-components';
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { getItemsWithCorrectLuids } from '~src/Collections/sagas/CollectionSagas';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { reloadSpaceIfUpdatingCurrentSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

import { Messages } from '../../../codegen/Localize';
import { SetSensitiveLabelAction } from '../../actions/labels/SetSensitiveLabelAction';
import { defaultInitialState, DialogState, getActionDialogOptions } from '../../components/labels/LabelDialog';

export type SensitiveLabelDialogState = {
    readonly luid?: string;
    readonly note: string;
    readonly showSensitiveLabel: boolean;
}

export type SenstiveLabelDialogBodyProps = {
    readonly contentItem: LabelContentItem;
    readonly loading?: boolean;
}

/**
 * @deprecated remove with unifiedLabelsDialogEnabled
 */
export function* handleSetSensitiveLabel(action: SetSensitiveLabelAction) {
    try {
        yield call(openSenstiveLabelDialog, action);

        const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
        if (!maybeReloaded) {
          yield put(requestSpaceContents());
        }
    } catch(e) {
        yield put(requestFailed(e, Messages.errorUnknown()));
    }
}

/**
 * @deprecated remove with unifiedLabelsDialogEnabled
 */
export function openSenstiveLabelDialogCatalog({ contentItem, action, onSubmit }: {
    readonly contentItem: LabelContentItem;
    readonly action?: SetSensitiveLabelAction;
    readonly onSubmit?: () => void;
  }): Promise<unknown>  {

    const siteLuid = SessionSiteSelectors.siteLuid(getAppStore().getState());
    const { makeJsonRestApiRequest } = restApiService({siteLuid});

    const doAction: (formData: DialogState) => Promise<unknown> = ({ luid, isActive, message, labelValue }) => {
        return setOrDeleteLabel({
            category: 'sensitivity',
            makeJsonRestApiRequest,
            contentItems: [contentItem],
            labelContent: {
              active: isActive,
              elevated: undefined,
              message: message,
              value: labelValue,
            }
          }).then(async (_: unknown) => {
            ToasterService.instance.pop({
              type: ToastType.Info,
              text: Messages.labelUpdateSuccess({
                LABEL_CATEGORY: Messages.labelCategorySensitivity(),
                CONTENT_NAME: contentItem.contentName,
              }),
            });
            if (onSubmit) {
              ToasterService.instance.markToastsAsDoNotDismissOnLocationChange();
              onSubmit();
            }
          }).catch((_: unknown) => ToasterService.instance.pop({
            type: ToastType.Error,
            text: Messages.labelUpdateError({
              LABEL_CATEGORY: Messages.labelCategorySensitivity(),
              CONTENT_NAME: contentItem.contentName
              })
          }));
    };

    const initialBodyProps: SenstiveLabelDialogBodyProps = { contentItem, };
    const modalInstance = openReactActionDialog(getActionDialogOptions({
      initialBodyProps,
      initialFormData: defaultInitialState('sensitivity'),
      doAction,
      dialogType: 'sensitivity',
    }));

    return modalInstance.result;
}

/**
 * @deprecated remove with unifiedLabelsDialogEnabled
 */
export function openSenstiveLabelDialog(action: SetSensitiveLabelAction): PromiseLike<unknown> {
    const itemWithCorrectLuid = getItemsWithCorrectLuids([action.item])[0];
    const { luid: contentId, name: contentName, contentType } = itemWithCorrectLuid;
    if (!isLabelContentType(contentType)) {
      throw new Error(`${contentType} Sensitive Label cannot be put on this content type`);
    }

    const contentItem: LabelContentItem = { contentId, contentName, contentType };

    return openSenstiveLabelDialogCatalog({ contentItem, action });
}